var resources = require('items-view-strings');
    var strings = resources['_1pYVBINCt0PPyVac+Cu+8A'];
export { strings };
export default strings;
